module.exports = __webpack_public_path__ + "static/media/money-management.eb94bf68.png";